import { useEffect, useState } from "react";
import Select from "react-select";

const AssignModal = ({
    open,
    onClose,
    type, // 'primary', 'special', 'points'
    userId,
    primaryBadges,
    specialBadges,
    onSubmit,
    isLoading,
}) => {
    const [selectedBadge, setSelectedBadge] = useState(null);
    const [points, setPoints] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        setSelectedBadge(null);
        setPoints("");
        setError("");
    }, [open, type]);

    if (!open) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        setError("");
        if (type === "primary" && !selectedBadge) {
            setError("Please select a primary badge.");
            return;
        }
        if (type === "special" && !selectedBadge) {
            setError("Please select a special badge.");
            return;
        }
        if (type === "points" && (!points || isNaN(points) || Number(points) <= 0)) {
            setError("Please enter a valid points value.");
            return;
        }
        onSubmit(type, selectedBadge ? selectedBadge.value : null, points);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-sm relative">
                <button className="absolute top-2 right-3 text-xl" onClick={onClose}>
                    &times;
                </button>
                <h3 className="font-bold text-lg mb-4">
                    {type === "primary"
                        ? "Assign Primary Badge"
                        : type === "special"
                            ? "Assign Special Badge"
                            : "Assign Points"}
                </h3>
                <form onSubmit={handleSubmit}>
                    {(type === "primary" || type === "special") && (
                        <div className="mb-3">
                            <label className="block text-sm font-medium mb-1">
                                {type === "primary" ? "Primary Badge" : "Special Badge"}
                            </label>
                            <Select
                                options={
                                    type === "primary"
                                        ? primaryBadges.map((b) => ({
                                            value: b._id,
                                            label: b.name,
                                        }))
                                        : specialBadges.map((b) => ({
                                            value: b._id,
                                            label: b.name,
                                        }))
                                }
                                value={selectedBadge}
                                onChange={setSelectedBadge}
                                placeholder="Select badge..."
                                isClearable
                            />
                        </div>
                    )}
                    {type === "points" && (
                        <div className="mb-3">
                            <label className="block text-sm font-medium mb-1">Points</label>
                            <input
                                type="number"
                                className="border rounded w-full p-2"
                                value={points}
                                onChange={(e) => setPoints(e.target.value)}
                                min={1}
                                required
                            />
                        </div>
                    )}
                    {error && (
                        <div className="text-red-500 text-sm mb-2">{error}</div>
                    )}
                    <button
                        type="submit"
                        className="w-full bg-bgprimary text-dark font-bold py-2 rounded mt-2"
                        disabled={isLoading}
                    >
                        {isLoading ? "Assigning..." : "Assign"}
                    </button>
                </form>
            </div>
        </div>
    );
};
export default AssignModal;